export default __webpack_public_path__ + "static/media/smilies04.8f8d2f66.png";